import { HttpClient, HttpContext } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { IS_SPINNER_ACTIVE } from "src/app/util/interceptors";
import { UrlService } from "src/environments/urlService";
import { ConversionTerm, LoanConversion } from "./holding-utils";

@Injectable({
    providedIn: 'root',
  })
  
  export class HoldingBackendService {
    private readonly url;
  
    constructor(
      private http: HttpClient,
      private urlService: UrlService,
    ) {
      this.url = this.urlService.getFmsUrl() + 'holding/';
    }
  
    getInitialLoanData(fundId: number, companyId: number, period: Date): Observable<LoanConversion> {
      return this.http.get<LoanConversion>(this.url + 'loan/' + fundId + '/' + companyId + '/' + period,
        {
          context: new HttpContext().set(IS_SPINNER_ACTIVE, true),
          withCredentials: true,
        }
      ).pipe(
        map(data => ({
          ...data,
          isLoan: true,                                //initial value
          conversionTerm: ConversionTerm.WithinCap,    //initial value
        }))
      );
    }
}